<div class="list-container" *ngrxLet="dashboardInstallationState$ as installationState">
  <app-dashboard-tile-banners
    [dashboardStoreStatus]="dashboardStoreStatus$ | async"
    [tileType]="tileType"
  ></app-dashboard-tile-banners>
  <ng-container *ngIf="virtualScrollEnabled; else defaultList">
    <div
      class="installations-list"
      (scroll)="onScroll($event, installationState.canFetch, installationState.loading)"
    >
      <app-dashboard-tile-installation-list-item
        class="item"
        *ngFor="let installation of installationState.value; let i = index"
        (click)="goToInstallationDetails(installation.id)"
        [installation]="installation"
        [tileType]="tileType"
        [attr.data-index]="i"
      >
      </app-dashboard-tile-installation-list-item>
      <div class="item__item-loading" *ngIf="installationState.loading">
        <vi-loader [isLoading]="true" message=""></vi-loader>
      </div>
    </div>
  </ng-container>

  <ng-template #defaultList>
    <app-dashboard-tile-installation-list-item
      class="item"
      *ngFor="let installation of installationState.value"
      (click)="goToInstallationDetails(installation.id)"
      [installation]="installation"
      [tileType]="tileType"
    ></app-dashboard-tile-installation-list-item>
  </ng-template>
</div>
